module.exports = __webpack_public_path__ + "img/outside1.bcd4cbbc.jpg";